import _ from 'lodash';

export const makeAccountSalesHeader = () => {
  const array = [{ id: 'total', label: '합계' }];
  for (let index = 0; index < 12; index++) {
    let object = { id: index + 1, label: index + 1 + '월' };
    array.push(object);
  }
  return array;
};

const accountSales = [
  { id: 'total', label: '판매관리비 계' },
  { id: '급여', label: '급여' },
  { id: '퇴직급여', label: '퇴직급여' },
  { id: '접대비', label: '접대비' },
  { id: '복리후생비', label: '복리후생비' },
  { id: '여비교통비', label: '여비교통비' },
  { id: '차량유지비', label: '차량유지비' },
  { id: '소모품비', label: '소모품비' },
  { id: '지급수수료', label: '지급수수료' },
  { id: '보험료', label: '보험료' },
  { id: '사대보험', label: '사대보험' },
  { id: '건물관리비', label: '건물관리비' },
  { id: '경상연구개발비', label: '경상연구개발비' },
  { id: '세금과공과', label: '세금과공과' },
  { id: '수선비', label: '수선비' },
  { id: '운반비', label: '운반비' },
  { id: '도서인쇄비', label: '도서인쇄비' },
  { id: '광고선전비', label: '광고선전비' },
  { id: '교육훈련비', label: '교육훈련비' },
  { id: '비품', label: '비품' },
  { id: '지급임차료', label: '지급임차료' },
  { id: '연구비', label: '연구비' },
  { id: '외주용역비', label: '외주용역비' },
  { id: '협회비', label: '협회비' },
  { id: '운반비이자수익', label: '이자수익' },
  { id: '잡이익', label: '잡이익' },
  { id: '외환차익', label: '외환차익' },
  { id: '국고보조금', label: '국고보조금' },
  { id: '판매장려금', label: '판매장려금' },
  { id: '기부금', label: '기부금' },
  { id: '이자비용', label: '이자비용' },
  { id: '잡손실', label: '잡손실' },
  { id: '외환차손', label: '외환차손' },
  { id: '법인세등', label: '법인세등' },
];

export const makeSalesHeader = () => {
  const array = [{ id: 'total', label: '합계' }];
  for (let index = 0; index < 12; index++) {
    let object = { id: index + 1, label: index + 1 + '월' };
    array.push(object);
  }
  return array;
};
export const hqTyps = [
  { id: 'direct', name: '직접비' },
  { id: 'common', name: '공통비' },
  { id: 'total', name: '합계' },
];

export const makeTotalCommonCostHeader = () => {
  const array = [{ id: 'total', label: '합계' }];
  for (let index = 0; index < 12; index++) {
    let object = { id: index + 1, label: index + 1 + '월' };
    array.push(object);
  }
  return array;
};

export const makeAccountSalesData = (companies) => {
  console.log(companies, 'companies');
  const array = [];
  _.forEach(companies, (company) => {
    const companyObject = {
      companyCd: company.companyCd,
      companyNm: company.companyNm,
      rowSpan: accountSales.length,
      accounts: [],
    };
    _.forEach(accountSales, (item) => {
      const object = { id: item.id, label: item.label, data: [] };
      // for (let index = 0; index < 12; index++) {
      //   //header mapping
      //   const monthObject = {
      //     id: index + 1,
      //     value: `${Math.floor(Math.random() * 1000000000)}`,
      //   };
      //   object.data.push(monthObject);
      // }
      _.forEach(makeAccountSalesHeader(), (values) => {
        const monthObject = {
          id: values.id,
          value: `${Math.floor(Math.random() * 1000000000)}`,
        };
        object.data.push(monthObject);
      });
      companyObject.accounts.push(object);
    });
    array.push(companyObject);
  });
  
  return array;
};

const headquaterData = [
  {
    id: '1',
    name: 'BITOPLUS',
    rowSpan: 5,
    children: [
      {
        id: '1-1',
        name: '인프라영업본부',
      },

      {
        id: '1-2',
        name: 'NI영업본부',
      },
      {
        id: '1-3',
        name: 'SI영업본부',
      },
      {
        id: '1-4',
        name: '채널영업본부',
      },
      {
        id: 'total',
        name: '합계',
      },
    ],
  },
  {
    id: 'total',

    name: '합계',
    rowSpan: 1,
    children: [
      {
        id: 'total',
        name: '합계',
      },
    ],
  },
];

const teamData = [
  {
    id: '1',
    name: 'BITOPLUS',
    rowSpan: 6,
    children: [
      {
        id: '1-1',
        name: '전략사업본부',
        rowSpan: 4,
        children: [
          { id: '1-1-1', name: '전략사업1팀' },
          { id: '1-1-2', name: '전략사업2팀' },
          { id: '1-1-3', name: '전략사업3팀' },
          { id: 'subtotal', name: '본부계' },
        ],
      },
      {
        id: '1-2',
        name: 'SI사업본부',
        rowSpan: 1,
        children: [{ id: '1-2-1', name: 'SI사업본부', rowSpan: 1 }],
      },
      {
        id: 'subtotal',
        name: '합계',
        rowSpan: 1,
        children: [{ id: 'subtotal', name: '합계' }],
      },
    ],
  },
  {
    id: 'total',
    name: '합계',
    rowSpan: 1,
    children: [
      {
        id: 'total',
        name: '합계',
        rowSpan: 1,
        children: [{ id: 'total', name: '합계', rowSpan: 1 }],
      },
    ],
  },
];

const empData = [
  {
    id: '1',
    name: 'BITOPLUS',
    rowSpan: 10,
    children: [
      {
        id: '1-1',
        name: '전략사업본부',
        rowSpan: 9,
        children: [
          {
            id: '1-1-1',
            name: '전략사업1팀',
            rowSpan: 3,
            children: [
              { id: '1-1-1', name: '김인종 부장' },
              { id: '1-1-2', name: '양진섭 차장' },
              {
                id: 'subAmout',
                name: '소계',
              },
            ],
          },
          {
            id: '1-2',
            name: '전략사업2팀',
            rowSpan: 4,
            children: [
              { id: '1-2-1', name: '최광수 이사' },
              { id: '1-2-2', name: '조행래 전무' },
              { id: '1-2-3', name: '박재욱 차장' },
              {
                id: 'subAmout',
                name: '소계',
              },
            ],
          },
          {
            id: '1-3',
            name: '전략사업3팀',
            rowSpan: 2,
            children: [
              { id: '1-3-1', name: '심혁 이사' },
              {
                id: 'subAmout',
                name: '소계',
              },
            ],
          },
        ],
      },
      {
        id: 'subtotal',
        name: '합계',
        rowSpan: 1,
        children: [
          {
            id: 'subtotal',
            name: '합계',
            children: [{ id: 'subtotal', name: '합계' }],
          },
        ],
      },
    ],
  },

  {
    id: 'total',
    name: '합계',
    rowSpan: 1,
    children: [
      {
        id: 'total',
        name: '합계',
        rowSpan: 1,
        children: [
          {
            id: 'total',
            name: '합계',
            rowSpan: 1,
            children: [{ id: 'total', name: '합계' }],
          },
        ],
      },
    ],
  },
];

export const makeHqSalesData = () => {
  headquaterData.map((com) => {
    return com.children.map((hq) => {
      // 23년 예산
      hq.yearBudget = Math.floor(Math.random() * 1000000000);
      hq.data = [];
      return makeSalesHeader().map((value) => {
        const priceData = {
          id: value.id,
          direct: `${Math.floor(Math.random() * 1000000000)}`,
          common: `${Math.floor(Math.random() * 1000000000)}`,
          total: `${Math.floor(Math.random() * 1000000000)}`,
        };
        hq.data.push(priceData);
      });
    });
  });
  return Array.from(headquaterData);
};

export const makeTeamSalesData = () => {
  teamData.map((hq) => {
    return hq.children.map((dp) => {
      return dp.children.map((team) => {
        // 23년 예산
        team.yearBudget = Math.floor(Math.random() * 1000000000);
        team.data = [];
        return makeSalesHeader().map((value) => {
          const priceData = {
            id: value.id,
            direct: `${Math.floor(Math.random() * 1000000000)}`,
            common: `${Math.floor(Math.random() * 1000000000)}`,
            total: `${Math.floor(Math.random() * 1000000000)}`,
          };
          team.data.push(priceData);
        });
      });
    });
  });
  return Array.from(teamData);
};

export const makeEmpSalesData = () => {
  empData.map((com) => {
    return com.children.map((hq) => {
      return hq.children.map((team) => {
        return team.children.map((emp) => {
          // 23년 예산
          emp.yearBudget = Math.floor(Math.random() * 1000000000);
          emp.data = [];
          return makeSalesHeader().map((value) => {
            const priceData = {
              id: value.id,
              direct: `${Math.floor(Math.random() * 1000000000)}`,
              common: `${Math.floor(Math.random() * 1000000000)}`,
              total: `${Math.floor(Math.random() * 1000000000)}`,
            };
            emp.data.push(priceData);
          });
        });
      });
    });
  });
  return Array.from(empData);
};

const commonCostData = [
  {
    id: '1',
    name: 'BITOPLUS',
    rowSpan: 7,
    children: [
      {
        id: '1-1',
        name: '전체공통비(공통)',
      },
      {
        id: '1-2',
        name: '전체공통비(전략)',
      },
      {
        id: '1-3',
        name: '전체공통비(SI)',
      },
      {
        id: '1-4',
        name: '대표이사',
      },
      {
        id: '1-5',
        name: '경영기획본부',
      },
      {
        id: '1-6',
        name: '연구소',
      },
      {
        id: '1-7',
        name: '기술지원본부',
      },
    ],
  },
 
  {
    id: 'total',
    name: '합계',
    rowSpan: 1,
    children: [
      {
        id: 'total',
        name: '합계',
      },
    ],
  },
];

export const makeCommonCostData = () => {
  commonCostData.map((hq) => {
    return hq.children.map((dp) => {
      // 23년 예산
      dp.yearBudget = Math.floor(Math.random() * 1000000000);
      dp.data = [];
      return makeTotalCommonCostHeader().map((value) => {
        const monthObject = {
          id: value.id,
          value: `${Math.floor(Math.random() * 1000000000)}`,
        };
        dp.data.push(monthObject);
      });
    });
  });
  return Array.from(commonCostData);
};
